<template>
  <div style="padding: 20px">
    <el-button type="primary" @click="addMail">添加邮箱</el-button>
    <el-table :data="mailList" style="width: 70%">
      <el-table-column prop="mail" label="邮箱" width="300"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleEdit(scope.row)"
            plain
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
            plain
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-drag:common
      :visible="visible"
      :title="title"
      width="500px"
      @close="visible = false"
    >
      <el-form
        :rules="rules"
        :model="formData"
        ref="ruleForm"
        label-width="80px"
      >
        <el-form-item label="邮箱" prop="mail">
          <el-input
            v-model="formData.mail"
            placeholder="请输入邮箱"
            style="width: 300px"
            :maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="formData.password"
            placeholder="请输入密码"
            style="width: 300px"
            :maxlength="50"
            type="password"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="saveMail">保存</el-button>
        <el-button @click="visible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      mailList: [],
      visible: false,
      formData: {
        mail: '',
        password: '',
        mailid: ''
      },
      rules: {
        mail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur,change'
          }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    };
  },
  async mounted() {
    await this.getMailList();
  },
  methods: {
    async getMailList() {
      const { data } = await this.$fetch('/manage/windfarm/getMailList', {
        module: 'manage'
      });
      this.mailList = data.mailList;
    },
    async addMail() {
      this.visible = true;
      this.title = '新增邮箱';
      this.formData.mail = '';
      this.formData.password = '';
    },
    async handleDelete(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(async () => {
          await this.$postForm({
            url: '/manage/windfarm/deleteMailInfo',
            module: 'manage',
            data: { mailId: row.mailid },
            showLoading: true,
            showError: true,
            showSuccess: true
          });
          await this.getMailList();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    async handleEdit(row) {
      this.title = '编辑邮箱';
      this.visible = true;
      //console.log(row, 'row....');
      this.formData.mail = row && row.mail;
      this.formData.password = row && row.password;
      this.formData.mailid = row && row.mailid;
    },
    async saveMail() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          if (this.title === '新增邮箱') {
            await this.$postForm({
              url: '/manage/windfarm/saveMailInfo',
              module: 'manage',
              data: {
                mail: this.formData.mail,
                passWord: this.formData.password
              },
              showLoading: true,
              showError: true,
              showSuccess: true
            });
          } else {
            await this.$postForm({
              url: '/manage/windfarm/updateMailInfo',
              module: 'manage',
              data: {
                mail: this.formData.mail,
                passWord: this.formData.password,
                mailId: this.formData.mailid
              },
              showLoading: true,
              showError: true,
              showSuccess: true
            });
          }
          this.formData.mail = '';
          this.formData.password = '';
          await this.getMailList();
          this.visible = false;
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-table__empty-block {
  background-color: #fff;
}
/deep/.el-form {
  padding: 10px;
  .el-form-item__label {
    color: #ffffff;
  }
}
/deep/.btn {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    display: inline-block;
  }
}
</style>
